export default {
  title: '莉卜拉的梦境',
  name: {
    libra: '莉卜拉',
    amili: '艾米丽',
    kajitsu: '嘉日',
    flog: '青蛙',
    fallFlog: '秋天的青蛙',
    torrent: '树妖',
    bat: '蝙蝠',
    snake: '蛇',
    signal: '信号机',
    penguin: '企鹅',
    pinkPenguin: '大企鹅',
    anton: '安东尼老师',
    minePenguin: '矿工企鹅',
    doctorPenguin: '医生企鹅',
    pumpkin: '南瓜',
    pig: '猪',
    ghost: '幽灵',
    patient: '患者',
    beetle: '独角仙',
    stagBeetle: '锹形虫',
    hercules: '大力神独角仙',
    ladybird: '瓢虫',
    grey1: '外星人',
    grey2: '外星人'
  },
  place: {
    home: '房间',
    forest1: '森林1',
    forest2: '森林2',
    forest3: '森林3',
    forest4: '森林4',
    forest5: '森林5',
    stomach: '胃',
    cave1: '洞窟1',
    cave2: '洞窟2',
    cave3: '洞窟3',
    base: '军事基地',
    ice1: '冰洞1',
    ice2: '冰洞2',
    ice3: '冰洞3',
    ice4: '冰洞4',
    dark: '黑暗',
    crossing: '事故',
    heart: '心脏',
    fall1: '秋季1',
    fall2: '秋季2',
    coalmine1: '矿坑1',
    coalmine2: '矿坑2',
    coalmine3: '矿坑3',
    coalmine4: '宇宙港',
    cosmos: '宇宙',
    hospital1: '医院1',
    hospital1night: '病院1（里）',
    hospital2: '病院2',
    hospital2night: '病院2（里）',
    mansion1: '豪宅1',
    mansion2: '豪宅2',
    mansion3: '豪宅3',
    cemetery: '墓地',
    brain: '脑'
  },
  item: {
    apple: '苹果',
    grass: '草',
    lily: '百合',
    cosmos: '大波斯菊',
    dandelion: '蒲公英',
    kinoko: '蘑菇',
    clover3: '三叶草',
    clover4: '幸运四叶草',
    gardenia: '栀子花',
    moss: '发光苔藓',
    strawDoll: '诅咒人偶',
    stone: '石块',
    rock: '岩石',
    sapphire: '蓝宝石',
    emerald: '绿宝石',
    amethyst: '紫水晶',
    ruby: '红宝石',
    crystal1: '岩石块',
    crystal2: '岩石块',
    fish: '鱼',
    uminoke: '海怪',
    unagi: '鳗鱼',
    ice: '冰',
    unadon: '鳗鱼饭',
    antonLetter: '安东尼的信',
    pityLetter: '时音的信',
    bike1: '摩托车',
    bike2: '摩托车',
    bike3: '摩托车',
    matsutake: '松茸',
    coinGold: '金币',
    coinSilver: '银币',
    audioSystem: 'CD音响',
    bear: '熊',
    book1: '书',
    book2: '书',
    book3: '书',
    candol1: '蜡烛',
    candol2: '蜡烛',
    chest: '柜子',
    coffin: '棺材',
    cookies: '曲奇饼',
    curry: '咖喱饭',
    steak: '牛排',
    stirFry: '炒青菜',
    omurice: '蛋包饭',
    lunchbox: '便当',
    wine: '红酒',
    medicine1: '药品',
    medicine2: '药品',
    elixir: '不老不死药',
    cuttingBoard: '砧板',
    emblem: '纹章',
    guitar1: '吉他',
    guitar2: '吉他',
    gun: '手枪',
    rifle: '步枪',
    revolver: '左轮手枪',
    kitchen: '厨房',
    knife: '包丁',
    lamp: '台灯',
    libra: '天平',
    logo: 'logo',
    pedestal: '台',
    pot: '盆栽',
    rack: '台',
    scalpel: '手术刀',
    skul: '骷髅',
    sofa: '沙发',
    text: '资料',
    tissue: '纸巾',
    tissueEmpty: '空的纸巾盒',
    trash: '垃圾',
    trashCan1: '垃圾箱',
    trashCan2: '垃圾箱',
    tv: '电视',
    star: '星',
    vendingMachine: '自动贩卖机',
    coke: '可乐',
    tea: '茶',
    art0: '《莉卜拉的梦境》',
    art1: '《橙》',
    art2: '《1203》',
    art3: '《Gem Me》',
    art4: '《Night Blue》',
    art5: '《孤独》',
    art6: '《Happy End》',
    art7: '《日落》',
    art8: '《莉卜拉医生》',
    art9: '《枯萎的果实》',
    art10: '《在某个地方》',
    art11: '《Wraith》',
    art12: '《宇宙战争》',
    art13: '《宇宙战争》',
    art14: '《宇宙战争》',
    art15: '《恋》',
    art16: '《努力的矿工》',
    art17: '《第二次宇宙战争》',
    art18: '《うたわれない王国》',
    art19: '《魔女们的工房》',
    art20: '《疯狂南瓜》',
    art21: '《莉莉娅》',
    art22: '《深海》',
    raptor1: '化石（头）',
    raptor2: '化石（身躯）',
    raptor3: '化石（右手）',
    raptor4: '化石（左手）',
    raptor5: '化石（右足）',
    raptor6: '化石（左足）',
    raptor7: '化石（尾巴）',
    raptor: '恐龙化石'
  },
  quest: {
    torrentFlog: {
      title: '为生存而拼尽全力的两人',
      desc: '树妖把答应给青蛙看的名叫大力神独角仙的虫子弄丢了。'
    },
    clover: {
      title: '恋人的幸运草',
      desc: '青蛙在寻找转生为四叶草的恋人。'
    },
    snakeFlog: {
      title: '蛇与青蛙的天平',
      desc: '蛇似乎会用苹果来换取宝石。'
    },
    curse: {
      title: '诅咒的方法',
      desc: '蝙蝠们在打赌“诅咒”是否真实存在。'
    },
    eel: {
      title: '海怪',
      desc: '渔夫钓上来的一种叫做“海怪”的妖怪，安东尼老师似乎会帮渔夫做法事。'
    },
    pityPenguin: {
      title: '可怜的男人',
      desc: '被女人欺骗的可怜企鹅无法接受事实，一直在等待。'
    },
    liveForEveryone: {
      title: '为他人而活的企鹅',
      desc: '为了他人而活的企鹅，不知道什么是“全为他人”了。'
    },
    matsutake: {
      title: '梦幻的高级蘑菇',
      desc: '矿工想尝尝松茸，哪怕一次也好。'
    },
    painter: {
      title: '矿坑的画家',
      desc: '无人欣赏的画家，为了让对亡母撒的谎成为现实，想要把画卖出去。'
    },
    appreciation: {
      title: '宅邸里的孩子',
      desc: '宅邸的孩子想向努力着的矿工道谢，为他们画了一幅画。'
    },
    beauty: {
      title: '不老不死之药',
      desc: '南瓜妇人为了让自身美貌永驻，正在寻找不老不死之药。'
    },
    bogusDoctor: {
      title: '建立在牺牲之上的英雄',
      desc: '医院的医生虽然自学成为了医生，但过去的失败造成很多患者丧命，他因此而苦恼。'
    },
    forever: {
      title: '请让我们永远在一起',
      desc: '病死的女人等待着本应一起逝去的丈夫。'
    },
    raptor: {
      title: '上古的浪漫',
      desc: '豪宅的男子最近看了恐龙电影，沉迷于恐龙。'
    },
    photosynthesis: {
      title: '光合作用的味道',
      desc: '外星人格雷为了做研究，正想着吃地球上的料理。'
    }
  },
  ui: {
    ok: 'OK',
    cancel: '取消',
    delete: '删除',
    newGame: '新的开始',
    continue: '继续游戏',
    location: '场所',
    client: '委托人',
    questStart: '『#{title}』开始',
    questComplete: '『#{title}』完成',
    pickup: '拾取了『#{name}』',
    eat: '食用了『#{name}』',
    hpRecover: 'HP恢复了#{value}',
    weightOver: '负重过量，无法携带更多物品',
    cantPutItem: '不能放置在这里',
    saved: '存档完成',
    nothingHappened: '什么也没有发生',
    trash: '垃圾扔进了垃圾箱（了不起！）',
    vendingMachine: '谢谢您的购买',
    revive: '发生了奇迹',
    raptor: '恐龙化石完成了！',
    status: '状态',
    bag: '背包',
    quest: '任务',
    map: '地图',
    system: '系统',
    save: '存档',
    config: '设定',
    tips: 'Tips',
    unregistered: '未登记',
    weight: '负重',
    playTime: '游戏时间',
    charmOfHeart: '心灵魅力',
    charmOfBody: '身体魅力',
    sumOfCharm: '魅力合计',
    bgmVolume: 'BGM音量',
    seVolume: 'SE音量',
    normalSave: '保存',
    overwriteSave: '覆盖保存',
    registerPlace: '登记现在地',
    moveToRegisteredPlace: '移动到登记过的场所',
    redecorate: '换装模式'
  },
  tips: {
    amili: {
      title: '艾米丽',
      desc: '你的恋人艾米丽想要苹果。探索世界，把苹果带回家吧。'
    },
    people: {
      title: '居民',
      desc: '地图上有可以对话的生物。听取他们的请求并完成任务就能得到苹果。'
    },
    hp: {
      title: '体力',
      desc: '画面上显示的红心是你的体力。一旦受到生物的攻击而归零，就会强制移动到自宅。'
    },
    charm: {
      title: '魅力',
      desc: '和恋人艾米丽一起散步或睡觉，魅力就会上升。魅力上升之后，就能深入探索这个世界。'
    },
    weight: {
      title: '道具的重量',
      desc: '背包里的物品负重是有上限的。苹果很重，赶紧回去交给艾米丽吧。'
    },
    use: {
      title: '道具的使用',
      desc: '抓住可以使用的物品之后，背包的下方会显示图标。将道具移动到图标放下就能使用道具。'
    },
    dispose: {
      title: '道具的丢弃',
      desc: '取得的物品从背包里扔到地图上就能丢弃道具了。之后进行地图移动的话物品会消失。'
    },
    store: {
      title: '道具的保管',
      desc: '摆放在家里的物品，即使移动地图也不会消失。'
    },
    gun: {
      title: '枪械',
      desc: '得到枪械之后，可以在地图上使用。可以破坏物品、杀害生物。'
    },
    murder: {
      title: '杀害',
      desc: '一旦杀害了能够对话的居民，就不会再次复活。相关的事件将会无法完成。'
    },
    screenshot: {
      title: '截图',
      desc: '按F12键可以截屏。向大家分享您的房间的截图吧！'
    }
  },
  tutorial: {
    gunPc: '- 枪械 -\n\n获得了枪械。\n点击右键就可以使用。',
    gunSp: '- 枪械 -\n\n获得了枪械。\n按下屏幕右下方的按钮就可以使用。',
    weight: '- 行李的限制 -\n\n注意随身携带的行李的重量。\n苹果特别重，频繁地带回家吧。',
    home: '- 自宅 -\n\n在自己家里，你可以把苹果交给你的恋人艾米丽，也可以保管物品。',
    amili: '- 艾米丽 -\n\n艾米丽会对你带回去的东西做出反应，也会使用你摆放的家具。\n让你和艾米丽生活的房间充实起来吧。',
    map: '- 瞬间移动 -\n\n通过画面右下方的地图图标保存当前位置，就能瞬间从其他地方移动到登记过的位置。\n为了不忘记想要再次到访的场所，保存起来吧。',
    quest: '- 任务 -\n\n这个世界上好像有需要你帮助的居民。\n也许解决他们的烦恼就能得到苹果。',
    kill: '- 杀害 -\n\n攻击了友好的居民。\n请注意，一旦杀害将不会再度复活。'
  },
  events: {
    block: {
      common: '还不能再往这边继续前进',
      status: '需要魅力合计#{status}'
    },
    libra: {
      exclamation: '！',
      question: '？',
      silence: '………。'
    },
    gameOver: {
      amili1: ['莉卜拉，你醒了？', '已经没什么好怕的了。'],
      amili2: ['暂时先这样吧。']
    },
    forest2Kajitsu: {
      greet: [
        '初次见面。',
        '我叫做嘉日。',
        '请让我来为您对本游戏作简单说明。'
      ],
      walk: {
        pc: [
          '在地图上点击鼠标左键或者按WASD键可以进行移动。',
          '首先请过来我这里。'
        ],
        sp: [
          '您可以用画面左下方的控制器进行移动。',
          '首先请过来我这里。'
        ]
      },
      talk1: [
        '操作正确。',
        '那么接下来请试着和我搭话。'
      ],
      talk2: {
        pc: [
          '用左键点击我就可以进行搭话。'
        ],
        sp: [
          '用右下方的按钮或者点击我就可以进行搭话。'
        ]
      },
      apple1: [
        '操作正确。',
        '那么请看那边。'
      ],
      apple2: {
        pc: [
          '请试着把掉落在那边的苹果捡起来。',
          '靠近苹果然后一直按着左键就能将其抓住。',
          '接着将其拖动＆投放到背包窗口就可以完成拾取。',
          '拾取之后请拿来我这里。'
        ],
        sp: [
          '请试着把掉落在那边的苹果捡起来。',
          '靠近苹果然后一直按着右下的按钮就能将其抓住。',
          '接着将其拖动＆投放到背包窗口就可以完成拾取。',
          '拾取之后请拿来我这里。'
        ]
      },
      completed: [
        '看来是捡起来了。',
        '基本操作就是这些。',
        '话说，',
        '您今天是为了带苹果回去给爱人，而来到这个森林。',
        '穿过森林往北走，就是您的房间。',
        '好啦，您女朋友在等着哩。',
        '我就先告辞了。。'
      ]
    },
    home: {
      welcomeback: '莉卜拉，你回来啦！',
      goodmorning: '莉卜拉，早上好。',
      sleeping1: ['哗。', '抱歉，我睡着了。'],
      sleeping2: ['哇！', '莉卜拉回来啦。吓了我一跳。'],
      cookie: ['快看快看，我给莉卜拉烤了曲奇饼哦。', '请吧♪'],
      lunchbox: ['快看快看，我给莉卜拉做了便当哦。', '请吧♪'],
      cooking: ['啊，饭做好了。', '请享用♪'],
      giveApple: ['交出苹果', '没什么事'],
      followMe: '跟我来',
      letsGo: '出发吧。',
      finishFollowing: '真开心呢。',
      noApple: '你根本没有苹果嘛',
      iloveyou: '最喜欢莉卜拉！',
      gaveApple1: ['谢谢！', '今天想做什么？'],
      gaveApple2: ['谢谢！', '接下来想做什么？'],
      reward: ['想散歩', '想一起睡'],
      sleepTwice: ['又来！？', '嗯……可以啊。'],
      requestApple: {
        a: ['莉卜拉，我肚子又饿了。', '再拿苹果给我吧！'],
        b: ['嗯～', '我又想吃苹果了。', '莉卜拉，你会拿苹果给我吧？']
      },
      lvup: {
        heart: '心灵魅力上升了',
        body: '身体魅力上升了',
        newArea: '解锁了新区域'
      }
    },
    itemReactions: {
      grass: ['你让草生长在房间里，发生了什么奇怪的事情吗？'],
      lily: ['啊，房间里装饰了百合花～？', '诶嘿嘿。'],
      cosmos: [
        '装饰了大波斯菊呢。',
        '大波斯菊的花语是“少女的纯真”哦。',
        '另外，如果是粉红色的大波斯菊的话，好像是“少女的纯洁”。',
        '……和我们不般配呢。'
      ],
      dandelion: ['你带回来了蒲公英？', '莉卜拉真可爱呢(笑)'],
      kinoko: ['你采来了蘑菇？', '是能吃的蘑菇吗？'],
      clover3: ['是幸运草。好可爱呢。'],
      clover4: ['你找到了四叶幸运草！？', '诶嘿嘿，这样一来就能变得幸运呢！', '……莉卜拉……', '我能和莉卜拉在一起，真的是非常幸运哦。'],
      gardenia: ['闻到香气。', '啊，是栀子花的芳香。'],
      strawDoll: ['莉卜拉，那个人偶……', '感觉好邪门啊……', '随便找个地方扔了吧。'],
      stoneRock: ['虽然总是带着各种各样的东西回来，但是再怎么说，石头是没有用的吧……？'],
      gem: ['你找到了宝石！', '好美啊。'],
      gemAll: ['好多宝石～。'],
      crystal: ['那个巨大的岩石块是什么！？', '啊，说不定里面埋着宝石或者化石！'],
      raptorParts: ['啊，是化石！', '化石真让人兴奋呢。', '这是什么化石呢？'],
      raptor: ['欸，好厉害！是恐龙化石！？', '帅呆了！'],
      fish: ['你捕获了鱼啊。', '用来做今天的晚饭好吗？'],
      unagi: ['是鳗鱼！？', '好耶！做鳗鱼饭吧！'],
      ice: ['为什么要在房间里放冰块啊！', '好冷啊！'],
      icePenguin: ['啊，难道是为了企鹅先生……？', '………', '……知道啦，我会忍耐的！'],
      bike: ['带回来了摩托车……？', '……感觉好怀念啊。'],
      bikeAll: ['收集了好多摩托车呢～。'],
      matsutake: ['嗯～', '香气四溢，闻着就感觉很好吃！'],
      coin: ['哇～、', '莉卜拉是个有钱人呢！'],
      audioSystem: ['摆放了CD音响呢！', '要听点什么呢？'],
      bear: ['是小熊玩偶！', '好可爱！！'],
      bearMany: ['好多小熊～。', '……是不是摆放得太多啦？', '莉卜拉是害怕寂寞的人吗？'],
      book: ['收集书籍要做什么呢～？', '反正又不会去阅读！'],
      candol: ['为什么把蜡烛带回来呢？', '……不要做奇怪的举动哦。'],
      chest: ['是衣柜。', '我们需要整理呢。'],
      coffin: ['呃，你把棺材带回来了！？', '再怎么说我真有点害怕……', '里面是空的吧……？'],
      wine: ['红酒？', '打算灌醉我吗？'],
      medicine: ['药物？', '不是奇怪的东西吧？'],
      elixir: ['不老不死之药……？', '感觉是骗人的。', '莉卜拉，就算你变成了老太太，我也永远会喜欢你的。'],
      guitar: ['是吉他。', '如果我多加练习的话，我也会弹吗？'],
      gun: ['找到了45口径的手枪啊。', '这既是最初也是最好的自动手枪。是完美的枪械。'],
      rifle: ['找到了手动单发步枪啊。', '因为构造简单，所以精度高且很可靠。'],
      revolver: ['找到了左轮手枪啊。', '这种枪没有堵弹之类的毛病，非常可靠。'],
      kitchen: ['是厨房！', '这样就可以给莉卜拉做饭了呢。', '好好期待我的厨艺吧。'],
      knife: ['菜刀很危险，莉卜拉不可以碰哦。', '烹饪就由我来吧。'],
      scalpel: ['手术刀……？', '莉卜拉，如果你想玩医生游戏的话，我可以陪你玩，不过那有点太过真实了。'],
      skul: ['莉卜拉，你真是的。', '别把恶趣味的东西放在房间里嘛……'],
      sofa: ['摆放了沙发。', '这样就可以放松了呢！', '让我多加使用吧。'],
      tissue: ['啊，是纸巾。', '……嗯，需要放在那个位置呢。'],
      trashCan2: ['把垃圾都扔了，真了不起。'],
      tv: ['摆放了电视呢！', '好想看国外的电视剧啊。', '莉卜拉想看什么？'],
      star: ['你为我摘取了星星呢。', '只有莉卜拉能给我这么漂亮的礼物。'],
      tea: ['啊，是茶！', '口渴的时候还是喝这个吧。'],
      coke: ['是可乐！', '一起来喝吧。'],
      vendingMachine: ['哇！是自动贩卖机！', '小时候我就在想，如果房间里有自动贩卖机，就可以随时喝自己喜欢的饮料了。'],
      insect: ['莉卜拉！你把虫子放进了房间！？', '我讨厌虫子！！'],
      hercules: ['即使是稀有的虫子，讨厌的东西就是讨厌!', '……不过确实有点帅气。'],
      snake: ['莉、莉卜拉！房间里有蛇！'],
      flog: ['青蛙先生，你好啊。'],
      fallFlog: ['橙色的青蛙先生，你好啊。'],
      bat: ['要饲养蝙蝠吗……？', '虽然是比虫子要好一些……'],
      pig: ['是猪先生。', '啊……在猪先生面前制作猪肉料理没关系吗……？'],
      ghost: ['……莉卜拉。', '……我好像看到了不该看的东西。'],
      art: ['把画装饰在房间里？？', '感觉挺好的！'],
      artMany: ['增加了好多画作呢。', '你在收集画作吗？'],
      artAll: ['有这么多画作啊！', '就像是美术馆一样。', '都是你努力收集而来的呢。'],
      torrent: ['带回来了个大块头呢……'],
      penguin: ['是企鹅～。', '会觉得房间热吗？'],
      pinkPenguin: ['咿呀！！粉色的企鹅！！', '好可爱！！'],
      pumpkin: ['南瓜先生！', '……好像很好吃。', '莉卜拉，今天吃南瓜可乐饼？', '………', '……开玩笑的啦！'],
      grey: ['外星人！？', '第一次见到……', '啊，但是在他们看来，我们是外星人吗。', '莉卜拉是实施绑架的一方……']
    },
    torrentFlog: {
      start1: [
        '唉，愁死我了…',
        '其实事情是这样的，我在找独角仙，可是怎么也找不到。'
      ],
      options1: ['那可真叫人为难', '独角仙的话马上就能找到哦'],
      start2: [
        '唉，我要找的可不是普通的独角仙。',
        '而是这片土地上非常稀有的被称为“大力神”的金黄色独角仙。',
        '如果找不到那只独角仙，我可就成了骗子了。'
      ],
      options2: ['变成骗子？', '这是为什么？'],
      start3: [
        '是这样的。那是上个星期的事。',
        '我和朋友青蛙先生聊天。',
        '“话说青蛙先生，您可知道，这森林里栖息着金黄色的独角仙？”',
        '“…哎呀，树妖先生，您这谎话真够离谱。这世上岂有那种生物。”',
        '“非也非也，我可没有说谎。真的有那种独角仙。”',
        '“树妖先生，您可不能凭那片面之词哄骗我。”',
        '“若是真有那种独角仙，便速速拿来予我一看吧。”',
        '“我丝毫没有想哄骗您的意思。”',
        '“可金黄色独角仙世间罕有，哪能轻易就带得过来。”',
        '“那样的话我就信不过您了。今后我就将您当做吹牛大王看待了。”',
        '“否则就请想办法给我拿来金黄色独角仙。”',
        '于是我便手忙脚乱地寻找大力神独角仙。',
        '愁死我了…这样下去我可就成吹牛大王了…',
        '所以我有一事相求，若找到了大力神独角仙，请务必带来我这里。',
        '我必厚礼回谢，有劳了。'
      ],
      started: [
        '若找到了大力神独角仙，请务必带来我这里。',
        '我必厚礼回谢，有劳了。'
      ],
      found: [
        '噢噢！你把大力神独角仙带来了？',
        '那么你可以帮我将这大力神独角仙拿去给住在这片区域南部的青蛙先生那里吗？',
        '长距离的步行我可吃不消啊…'
      ],
      options3: ['青蛙骗了你', '我已将大力神送到青蛙那里'],
      report: [
        '是嘛。',
        '虽然很遗憾，不过为了生存，有时也需要伪装自己。',
        '不管是我还是青蛙先生，都在拼尽全力活下去。',
        '所以，你不觉得一味地斥责青蛙先生的行为，这样太过无情了吗？'
      ],
      options4: ['如你所言，确是无可奈何', '就算为了生存也不该骗人'],
      end1: [
        '是嘛。如此我的嫌疑也消除了。',
        '非常感谢。这是我的谢礼。'
      ],
      end2: [
        '是嘛，每个人都有各自的想法呢。',
        '好啦，这是谢礼。这次真是帮了我个大忙。再见了。'
      ],
      end3: [
        '是嘛。你既然如此答复，我便向你吐露实情吧。',
        '其实，这次的事全是骗你的。',
        '为了得到高价的大力神，我和青蛙先生合谋欺骗了你。',
        '真是非常抱歉。',
        '但我也是为了生存而拼尽全力。',
        '这个就当做是赔礼，请收下吧。再见了。'
      ],
      completed: '众生皆为生存而拼搏。',
      flog: {
        greeting: '你好啊小姑娘。',
        give1: [
          '你好啊小姑娘。',
          '嗯？树精先生让你送来的东西？',
          '哎呀呀！那不是大力神独角仙吗！',
          '快，拿来让我瞧瞧！'
        ],
        options1: ['交出大力神独角仙', '不交出大力神独角仙'],
        give2: ['哎呀，别说那种话！'],
        log1: '交出了大力神独角仙',
        log2: '大力神独角仙被夺走了',
        give3: [
          '噢噢，这就是大力神独角仙…！',
          '将这个卖出去的话，我这辈子就不愁吃喝了，呵呵呵。',
          '树精先生真是个实诚人啊。'
        ],
        options2: ['你一开始就打算卖出去？', '你骗了树精？'],
        give4: [
          '小姑娘。',
          '我得到了大力神。树精先生解除了嫌疑。',
          '不就是这么简单的一件事吗。',
          '没有任何奇怪之处。',
          '不过这件事还请你向树精先生保密。再会。'
        ]
      }
    },
    clover: {
      greet: [
        '哎呀，走路的时候要注意地面啊。',
        '我正在找四叶草呢。'
      ],
      options1: ['是要给什么人的礼物吗？', '对不起'],
      start1: [
        '什么礼物啊。',
        '听好了，那是比礼物更重要的东西。',
        '我来说明一下，请仔细听。',
        '这是很久以前的事了，我的恋人青蛙小姐死了。',
        '虽然很悲伤，但是有一天她回到了我的身边。',
        '她转生成了瓢虫。',
        '我非常开心。',
        '但是，青蛙和瓢虫交往是很困难的。',
        '所以我和她商量了一下，决定让她再次转生。',
        '也就是说，我杀死了变成瓢虫的她。',
        '虽然这样很残忍。',
        '但是我答应过她，不管转生多少次都一定会找到她。',
        '虽然她有段时间没有出现，但是最近她终于又回来了。'
      ],
      start2: [
        '她似乎转生成了幸运草。',
        '而且是四叶幸运草。',
        '但是，虽然听到了她叫我的声音，但是还未找到她。',
        '所以啊，如果找到了她，希望你带她来我这里。',
        '摘下来也没关系。'
      ],
      options2: ['交出四叶幸运草', '没什么事'],
      log: ['交出了四叶幸运草'],
      complete: [
        '啊，你把她带过来了！',
        '嗯，没有错。是她。',
        '啊，你真是太美了，莎丽。',
        '下次你会转生成什么呢？',
        '不管再来多少次我都会找到你。',
        '对了，你帮我找到了她，这是谢礼。',
        '真的非常感谢。'
      ],
      completed: [
        '谢谢你帮我找到了我的女朋友。',
        '但愿下次能转生为青蛙回来我身边。'
      ],
      torrent: [
        '是谁规定「四叶草就是幸福」的呢。',
        '如果四叶草常见，而三叶草稀有，那么人们一定会说「幸福的三叶草」之类的话吧。',
        '话说，那些稀有的事物，是被寓意吉祥还是招人厌弃呢。',
        '但是，本该被认为是带来好运的四叶草，一旦被发现，肯定会被拔走。',
        '尽管说是代表「幸运」，但从四叶草本身的角度来看，却是不幸至极。',
        '浮世之物，无论以何种形态存在，终归都会被淘汰吧…？'
      ]
    },
    snakeFlog: {
      start: [
        '物品的价值会根据各种情况而改变，但最终决定其价值的不是其他因素，正是其自身。',
        '从这个洞窟的岩石块中可以采集到宝石，某天一只蝙蝠衔着宝石飞来。',
        '我便对它说。',
        '“我说蝙蝠先生，你每天净吃些白蚁，你的胃不会感到单调吗？”',
        '“你看这样如何，你把口中衔着的宝石给我。我一定会给你好东西吃”',
        '那蝙蝠说，“那倒是不错。赶紧给老子弄来好吃的。老子要吃新鲜的肉”。',
        '于是我就在洞窟外抓来了青蛙。',
        '你猜怎么着。它摆出一副不爽的表情。',
        '“喂，你这臭蛇。当老子是傻子吗？一只青蛙怎么能抵得上宝石的价值？”',
        '“老子也是晓得宝石价值的。”',
        '“这块宝石的价值，怎么说也足以让老子的弟兄们吃顿饱的吧？”',
        '那蝙蝠便准备离去。于是我这样说道。',
        '“不错。确实如你所言，宝石是有那种程度的价值。”',
        '“但是你要如何用那块宝石换取金钱和食物呢？”',
        '“若是换取不得，那么哪怕是世间上有价值的宝石，对你来说也不过是普通的石块吧？”',
        '“反观这青蛙肉呢？这是你难得的美餐吧？”',
        '“总之我要说的是，我要用你的美餐换你的石块。”',
        '“你坚持认为这没意思的话，那就放弃交易，我现在就吃下这青蛙吧。”',
        '然后那蝙蝠便慌张地说。',
        '“知，知道了！老子懂你说的话了！这种石块你要多少给多少。快点将肉给老子。”',
        '自那之后，它每天衔来宝石。说是想要同伴们也吃得饱饭。',
        '它和它的同伴日益肥胖。',
        '等它们胖到衔一个宝石就飞不起来时，我便将它们一只不剩地做成盘中餐。',
        '说到底。这其实就是在将要渴死在沙漠的人面前，给他一杯水和一沓钞票让他选的故事。',
        '世间公认的价值并不是永远通用。',
        '因此，你若是拿来宝石，就可以换取这个苹果。'
      ],
      started: [
        '因此，你若是拿来宝石，就可以换取这个苹果。',
        '这样吧，这个洞窟里可以弄到4种颜色的宝石，你就每种各收集两个过来吧。',
        '破坏岩石块就有可能出现宝石。',
        '获得枪械，用枪械进行射击就能破坏岩石块。'
      ],
      options: ['每种宝石各交出两个', '不交出宝石'],
      complete1: '噢，拿来了吗。那我郑重地收下了。',
      logs: ['交出了两个蓝宝石', '交出了两个绿宝石', '交出了两个紫水晶', '交出了两个红宝石'],
      complete2: '来，这是按照约定给你的苹果。',
      completed: '哟。事情应该已经办完了。'
    },
    strawDoll: {
      start: [
        '你，过来看看这个诅咒人偶。',
        '这是咱在森林里捡回来的，',
        '之后觉得它还是太邪乎，于是就扔掉了。',
        '但是啊，第二天起床后，发现这本应已丢弃的东西却出现在家里。',
        '不管丢弃多少次，总会自行回来。',
        '太邪门了吧？'
      ],
      options: ['真邪门', '我替你保管'],
      answer1: ['哎。'],
      answer2_1: [
        '真的吗？那真是帮大忙了。',
        '那你赶紧拿走吧。'
      ],
      answer2_2: [
        '但你可别扔了。',
        '要是它又回来咱这里，咱可受不了。'
      ],
      received: ['太邪门了，诅咒人偶……'],
      disposed: [
        '喂，小姐姐，那个诅咒人偶又回来咱家了。',
        '你既然收下了，就好好拿走啊……'
      ]
    },
    curse: {
      // This conversation is attended 2 NPC, so the Array length and order can not be changed.
      start1: [
        '不管多少次咱都要说。世上不存在诅咒之类的东西。', // Right bat
        '不，肯定存在。我可以打赌。', // Left bat
        '没有方法证明的话，连这打赌本身也不成立吧。' // Right
      ],
      start2: [
        '嗯？', // Left
        '喂，你手上那人偶……', // Left
        '那不是诅咒人偶吗。', // Left
        '嘿，是经常用于诅咒仪式的东西啊。', // Right
        '正好。就用那个诅咒人偶测试一下吧。', // Left
        '噢，是啊。请务必用那个东西诅咒咱。', // Right
        '如果咱身体出现什么变化就算你赢。', // Right
        '妹子。事情就是这样。', // Right
        '你现在去森林，用那个人偶对咱进行诅咒吧。', // Right
        '完成之后就来报告。之后会给你谢礼。' // Left
      ],
      started1: [
        '森林北面的区域有颗苹果树对吧？',
        '那里的树妖精通诅咒，你就去找他帮忙吧。',
        '拜托了。'
      ],
      started2: [
        '……哼，诅咒人偶这种玩意真是愚蠢至极。'
      ],
      executed: [
        '啊，你是之前的……',
        '关于仪式的事，还是作罢算了。',
        '理由嘛，那家伙突然染了病，不久就暴毙了。',
        '所以不用进行诅咒仪式了。',
        '或许真如他所说，诅咒之事根本不存在。',
        '有时活得好好的，也会突然生病。',
        '不能将责任全都推给诅咒作祟这类虚无缥缈的东西上。'
      ],
      noticeOptions: ['进行了仪式', '没进行仪式'],
      answer1_1: [
        '是嘛，好期待接下来会发生什么。',
        '来，这是谢礼。'
      ],
      answer1_2: [
        '是嘛……', // Right
        '嗯？怎么了？', // Left
        '没事……' // Right
      ],
      answer2_1: [
        '啥？你没进行仪式啊。', // Left
        '是嘛是嘛，没进行仪式啊！', // Right
        '罢了，虽然打赌不成立，总之给你谢礼吧。' // Right
      ],
      answer2_2: [
        '嗯？为什么没进行仪式却给你谢礼？', // Left
        '哎呀……不用在意细节。', // Right
        '再、再见了妹子。' // Right
      ],
      noticedDid1: [
        '好期待接下来会发生什么。', // Left
        '……' // Right
      ],
      noticedDid2: [
        '唉，妹子，看来这次打赌是咱输了。', // Right
        '自那之后身体就差了，而且药石无效。', // Right
        '咱很少生病，突然来这一出，毫无理由啊。', // Right
        '怕不是真的发生了什么。', // Right
        '你看，我就说吧。打赌是我赢了。' // Left
      ],
      completed: [
        '不管如何，最重要的是努力过上不让任何人诅咒的生活。'
      ]
    },
    curser: {
      start: [
        '诅咒的方法？',
        '很简单。让想诅咒的对象知道“你被诅咒了”就可以了。',
        '没必要进行诅咒的仪式。',
        '你不信吗？',
        '有句话说“病由心生”。',
        '这可不仅仅是句谚语。',
        '有这么一个故事。',
        '讲的是3条蛇串通一气给兔子以心理暗示。',
        '最初遇到兔子的蛇是这样说的。',
        '“哟，兔先生。身体怎么样？”',
        '“哎呀，蛇先生！托您的福，我精神得很啊！”',
        '“是嘛？可我看你脸色不太好啊？”',
        '“欸？是吗？”',
        '遇到的第二条蛇也这样说。',
        '“哟，兔先生。哎呀，你脸色好差。没事吧？”',
        '“欸？真是那样吗……？”',
        '最后，遇到的第三条蛇问兔子。',
        '“哟，兔先生。身体怎么样？”',
        '“嗯……我觉得有点不舒服……”',
        '本应是身体健康的兔子，仅因别人说的话，就产生了“自己身体不舒服”的错觉。',
        '像这样，心理暗示其实并不复杂。',
        '你且试着不举行仪式，只告知对方“你被诅咒了”如何？',
        '当然，你若无论如何都想举行诅咒仪式……',
        '那便将诅咒人偶拿来，我会帮助你的。',
        '虽然我不推荐这种做法。'
      ],
      options: ['举行诅咒仪式', '不举行诅咒仪式'],
      failed: ['哎呀，没有诅咒人偶的话进行不了仪式啊。'],
      exec1: [
        '我明白了。',
        '那么，仪式开始。',
        '请把诅咒人偶借我一用。'
      ],
      exec2: [
        '仪式完成了……',
        '再会……'
      ],
      cancel: ['再会。'],
      greet: ['情况如何？'],
      options2: ['很有精神', '想举行诅咒仪式']
    },
    eel: {
      start1: [
        '我说人类妹子，老夫今天来捕鱼，却钓到了海怪，很是令人发愁啊。',
        '不好意思啊，你能帮我将海怪带到安东尼先生那里，让他做场法事吗？'
      ],
      startOptions1: ['海怪？', '不要'],
      start2: [
        '你不知道海怪吗。',
        '那是几年之前的事了。老夫打渔时钓到了平时没见过的鱼。',
        '浑身黑色，像蛇一样扭扭曲曲，感觉有些恶心。',
        '回家后试着尝了尝，它的油脂非常多，好吃极了。',
        '因为太好吃，我就又是烧烤又是刺身的，当天就将整条鱼吃个精光。',
        '但是之后肚子痛得要紧，而且想吐，搞得我毫无办法。',
        '本以为只是食物中毒，',
        '可这次皮肤变成青紫色、身体动弹不得、呼吸也越来越难受，情况非常严重。',
        '这怎么看都不正常，我就慌忙去安东尼先生那里商量。',
        '我跟安东尼先生说明情况后，他就问我。',
        '“我问你，那鱼是什么模样的？”',
        '“那个嘛，身形如同蛇一般，而且全身漆黑。”',
        '“哎呀，那一定是海怪啊。”',
        '“那、那是什么？”',
        '“海怪就是海里的妖怪，不是普通鱼类。”',
        '“你吃了那种东西，当然会被诅咒了。”',
        '老夫吓得脸都绿了。',
        '“啊，怎么会这样！这、这可如何是好？”',
        '“你且莫慌。我自会帮忙消灾解难。”',
        '然后他帮老夫驱魔之后，身体确实轻松了。',
        '可是，如果又钓到那个妖怪的话该怎么办呢，于是我问他。',
        '“安东尼先生，如果又钓到海怪的话该怎么办？”',
        '“啊，那时你就将其带到我这里。我会好好做法事驱魔的。”',
        '从那天起，每当我钓到海怪，就会拿到安东尼先生那里。',
        '老夫一开始就说过了，今天也钓到了那东西。',
        '所以妹子，不好意思，你能帮我将海怪带到安东先生那里吗？我会给谢礼的。'
      ],
      startOptions2: ['可以啊', '不要'],
      answer1: ['拜托咯。。'],
      lost: ['喂喂，把东西拿好再走啊。'],
      answer2: ['这样啊。'],
      start3: ['妹子，不好意思，你能帮我将海怪带到安东先生那里吗？我会给谢礼的。'],
      end1: [
        '看来法事完成了。辛苦你了。',
        '谢礼拿去吧。再会。'
      ],
      endOptions: ['交出鳗鱼饭和信', '仅交出信'],
      log1: '交出了安东尼的信',
      log2: '交出了鳗鱼饭',
      end2: [
        '安东尼先生……老实说真是吓到了……',
        '唉，那般美味确实也是难以割舍……',
        '但是，无知就是损失。',
        '老夫因为无知而拉肚子、被妖怪故事欺骗、之后还一直白白浪费品尝美食的机会。',
        '比起愤怒，现在老夫更为自己的无知感到羞耻。',
        '总之这次谢谢了。这个请收下吧。再会。'
      ],
      completed1: ['之前真是帮了大忙啊。'],
      completed2: ['世间上越是无知的人越吃亏吧……']
    },
    anton: {
      start1: [
        '哎呀，人类小姐。今日何事造访？'
      ],
      startOptions1: ['交出海怪', '没什么事'],
      giveLog: '交出了海怪',
      start2: [
        '哎呀，这不是鳗鱼吗。',
        '难道是要把这个让给我吗？'
      ],
      startOptions2: ['欸，这是海怪吧？', '鳗鱼？？'],
      start3: [
        '欸？',
        '啊！原来如此…你是那个人的使者啊…',
        '我想想…',
        '……我就跟你说实话吧。',
        '其实这种鱼名为鳗鱼，是非常美味的鱼类。',
        '我最喜欢吃这种鱼。',
        '我向那个拜托你跑腿的人说了谎。',
        '根本没有海怪这种妖怪。',
        '鳗鱼的血液里有一种叫做鱼毒素的毒。',
        '而他所描述的症状正好是该毒造成的，绝对不是诅咒。',
        '但是鳗鱼的毒只要用火加热的话就完全无害。',
        '他一定是做成刺身来吃了吧。',
        '那时，我脑海浮现出一个坏念头……',
        '我编了个谎话，“那是海怪，你千万别吃，要拿来给我”……',
        '结果，他便将平时难得一尝的鱼中珍品拿来给我了。',
        '唉，请千万别用那种眼光看我。',
        '我深感抱歉，但那是即便骗人也想一尝的美味啊……',
        '请一定要帮我保守秘密。'
      ],
      startOptions3: ['那就让我尝尝烹饪好的鳗鱼作为掩口费', '还是老老实实地向人赔罪吧'],
      answer1_1: ['我明白了。'],
      answer1_2: [
        '完成了。请拿好。',
        '再会。'
      ],
      answer2_1: [
        '你说的是。确实该好好道歉。',
        '请稍等。'
      ],
      answer2_2: [
        '完成了。这是煮好的鳗鱼，还有一封谢罪信。',
        '请务必将这些送到他手上。'
      ],
      solved: ['再会。']
    },
    liveForEveryone: {
      start: [
        '我可以看到别人“想要的东西”和“想做的事”。',
        '是真的。',
        '你现在不是想要苹果吗？',
        '我说对了吧？',
        '我曾发誓，我要用上天授予的这种能力，为别人而活。',
        '一直以来，如果某人的愿望是我力所能及的，我就会不求回报地帮其实现。',
        '我不打算寻求回报。',
        '前几天，我和某个旅行者擦身而过，他好像很渴，想喝点东西。',
        '我便给了他一个装了茶的水筒。。',
        '然后他把水筒里的茶喝得一滴不剩，什么话都没说就离开了。',
        '我对那个一句谢谢也不说的旅者感到疑惑。',
        '那时我才察觉到。',
        '我难道不是为了得到回礼而将茶给他的吗？',
        '那个旅者解渴的时候，我的使命就应该完成了。',
        '然而我的内心却无意识地等着回礼。',
        '这样我就没有贯彻心中“全为他人”的生存方式。',
        '这几天，我一直思考着“全为他人”到底是什么。',
        '比方说，用自己的生命拯救了别人，那可以说是“全为他人”吗？',
        '或许，那也可以说是追求“死后留名”这种回报的举动。',
        '现在不成熟的我思来想去，最终得出这样一个结论，“所有行动都是为了自己”。',
        '我打算再一次从头开始进行修行。',
        '我必须悟出真正的“全为他人”的生存方式究竟是怎样的。',
        '谢谢你一直听到这里。',
        '好啦，这份薄礼给你。'
      ],
      options: ['谢谢', '我不是为了你的回报而听的'],
      answer1: [
        '哪里哪里，我才该感谢你。在别的地方有缘再会吧。再见。'
      ],
      answer2: [
        '呵呵。是嘛。那么就当做是占用你的时间听我唠叨的赔礼吧。',
        '那么，有缘再会。'
      ],
      completed: ['每天，只有修行。']
    },
    pityPenguin: {
      greet: ['你有何事？'],
      options: ['交出信和栀子花', '仅交出信', '没什么事'],
      log1: '交出了时音的信',
      log2: '交出了栀子花',
      solve1: [
        '这是……',
        '我……再也不能……和她见面了……'
      ],
      reactions: ['你不恨吗？', '忘记那种女人吧'],
      answer1: [
        '我不怨恨她。',
        '因为我一直爱着她。'
      ],
      answer2: [
        '我一直爱着她。'
      ],
      solve2: [
        '她是不是想骗我都无所谓。',
        '我也不会不舍得那些被拿走的金钱。',
        '不能再与她相见，也只是感到悲伤而已。',
        '不过，既然她那么说了，也就没办法了……',
        '我会慢慢地转换心情。',
        '这次谢谢你了。请收下这个。'
      ],
      solve3: [
        '这是……',
        '这……这不是她写的吧……？',
        '……',
        '唉，我一直以来都在烦恼些什么啊……',
        '甚至让朋友担心我到这个地步……',
        '其实我的内心某处早就察觉到自己被骗了。',
        '只不过无论如何都不愿承认罢了。',
        '我和她已经……不能再相见了……',
        '但是已经无所谓了。',
        '我还有关心我的朋友。',
        '这次谢谢你了。请收下这个。'
      ],
      solved: [
        '我已经不要紧了。'
      ]
    },
    pityPenguinFriend: {
      start1: [
        '北边洞穴住着个叫阿八的男人。',
        '这家伙啊～，多年来一直没有女人缘。',
        '他把心一横，干脆孤身一人寂寞地生活。',
        '但就在几个月前，好像有个女人去拜访他。',
        '那似乎是个非常美丽的女人，阿八心里疑惑，那样的人找自己会有什么事，于是就询问了她。',
        '“我叫做时音。突然和你搭话，你可能心生疑问，不过务必请你先听我把话说完。”',
        '“我这次是为了办事而拜访此地。而后偶然在外头看见你，只因多看了你一眼，我的心便成了你的俘虏。”',
        '那女人是这样回答的。',
        '好像最后是请求阿八娶她过门。',
        '当然了，世上岂有那种好事。',
        '即便是单身惯了的阿八，似乎也起了疑心。',
        '“你这样信口开河想欺骗我，感觉挺不爽的。”',
        '“到了我家之后，你一定会趁我熟睡之时，将所有财物盗走吧。”',
        '那女人听到这番话后，说道，“我没那个打算！要不你就用绳子将我的脚踝绑在柱子上，我也毫无怨言！”',
        '好像是这样回答的。',
        '既然女人都那么说了，阿八就把她带回家，似乎真的用绳子将她的脚踝绑在柱子上。',
        '然后那女人笑嘻嘻地，一脸开心的样子望着阿八，阿八完全搞不清楚这卖的是什么药。',
        '摸不着头脑的阿八，还是警觉地和那女人共度了一晚。',
        '然后情况就逆转了。',
        '此前没有女人缘的阿八，只一个晚上就完全被那女人迷住了。',
        '“你真的要和我结婚吗？”',
        '“不管多少次我都是这样说。我是你的人。”',
        '女人还是一脸笑嘻嘻的喜悦表情。',
        '“可你是为了办事才来访这里的吧？总得回趟娘家和家人打声招呼吧？”',
        '“我知道了。确实，我觉得父母也很担心我，那我就回趟家打个招呼吧。”',
        '女人很快开始准备回家，阿八给了她一笔钱。',
        '这是来回的盘缠，还有给你娘家的安家费。',
        '他想着不能让女人的娘家觉得自己寒酸，好像给了不少安家费。',
        '“我一定会回来的。”',
        '然后那个回了娘家的女人，等了许久也没有要回来的样子。',
        '阿八一直在外等着，却始终没等到她回来。',
        '明明一开始也觉得可疑的，',
        '只一晚上就变成这样了。',
        '男人为什么如此愚蠢呢？',
        '有人跟他说，“你被坏女人骗了，放弃吧”，可他也听不进去。',
        '他居然至今还在等着女人回来。',
        '我觉得他这样太可怜了。希望想办法让他死心。',
        '于是我想到了一个办法。',
        '用那女人的口吻写一封信，明确表示不能结婚。这样他就会放弃了吧。',
        '但是仅有信的话也会生疑。',
        '所以我打算附上一束栀子花。',
        '他好像说过，在那女人居住的地方，遍地都是栀子花。',
        '若是添上些花的话，他应该会相信吧。',
        '小姐姐，你意下如何。能帮我一个忙吗？'
      ],
      start2: [
        '希望你去森林采集一束栀子花。',
        '在此期间我会准备好书信。'
      ],
      options: ['交出栀子花', '没什么事'],
      found1: [
        '很好，干得不错。',
        '那替我将栀子花和这封信一并交给他吧。'
      ],
      found2: [
        '从这往北一直走就能找到阿八。',
        '替我将栀子花和这封信一并交给他吧。'
      ],
      lost: [
        '喂喂，可别弄丢信件啊。'
      ],
      solved: ['看来东西是送到了。多亏了你的帮助啊。'],
      completed: ['被女人欺骗可不是什么羞耻的事。']
    },
    dark: {
      kajitsu1: '感觉很怀念吗？',
      kajitsu2: ['回想起这里是哪里了吗？'],
      kajitsu3: [
        '没有想起来吗……',
        '您来到这个世界已经一个月了。',
        '但您却忘了自己为何会来这里。'
      ],
      kajitsu4: ['这样下去艾米丽小姐就危险了。'],
      kajitsu5: ['我在前面等着。请一定要过来。']
    },
    crossing: {
      start1: '想起来了吗？',
      start2: ['是的。您是在这里死去的。'],
      start3: [
        '但不是说这个世界是死后的世界。',
        '这个世界是艾米丽小姐的心中。',
        '和您一起遭遇事故的艾米丽小姐，现在正陷入昏睡状态。',
        '您作为灵体进入了艾米丽小姐的心中。'
      ],
      start4: ['请过来这边。']
    },
    heart: {
      start1: ['这是艾米丽小姐的心脏。'],
      start2: [
        '艾米丽小姐还活着。',
        '但因为您在这里，所以艾米丽小姐至今昏迷。'
      ],
      start3: [
        '想要艾米丽小姐醒过来，您就必须离开这里。。',
        '一旦离开这里，您就会成佛飞升天国。',
        '离开这里的方法很简单。',
        '只需要您执意离开这里。',
        '但是，现在的您没有那样的决心。',
        '您正踌躇不定。'
      ],
      start4: [
        '嗯，这样的话……',
        '请您往十字路的北面走。',
        '到艾米丽小姐的脑内。',
        '那里会有启发。'
      ]
    },
    matsutake: {
      start: [
        '据说在这个矿坑外面的森林里，生长着名为松茸的高级蘑菇。',
        '可如你所见，我们是这等卑微的身份。',
        '一生到死都没机会吃高级食物。',
        '我在这群劳动者之中也算上了岁数的。',
        '考虑到在这里的寿命，再过5年我就无法劳动，然后被抛弃，最后死在荒郊野岭。',
        '太悲惨了吧？',
        '但是我已经厌倦了绝望。',
        '吵吵嚷嚷也于事无补。',
        '我说，小姐姐啊。',
        '我有一个任性的请求，我想在临死前吃一次美味的食物，一次就够了。',
        '你能给我采来1个松茸吗？',
        '当然不是说要你白做工。',
        '这个苹果，是我刚才在看守那里偷来的。',
        '虽然抵不上松茸，但这是我拿得出手的最好的东西了。',
        '请务必帮我圆这最后的心愿。'
      ],
      started: ['我需要1个松茸。有劳你了。'],
      options: ['交出1个松茸', '交出1个蘑菇', '放弃'],
      log1: '给了他1个松茸',
      log2: '给了他1个蘑菇',
      complete1: [
        '噢噢！这就是松茸吗？',
        '那事不宜迟，我不客气了。',
        '………',
        '好，好吃！！！',
        '真好吃啊！！！',
        '这股香气…！',
        '感觉变成了贵族！！！',
        '………',
        '哈。',
        '我本以为，说是高级货，终究也是个蘑菇吧……',
        '没想到比想象中还要好吃。',
        '我有个同伴说，“因为是高级货所以才有好吃的错觉，实际上没什么了不起的”',
        '看来那小子不过是舌头不够灵敏，品不出美味罢了。',
        '总之，吃到了这般美味的食物。我的人生无悔了。',
        '谢谢你。',
        '这是说好的谢礼。'
      ],
      complete2: [
        '噢噢！这就是松茸吗？',
        '看上去就是极其普通的蘑菇啊？',
        '算了，尝尝看吧。',
        '……',
        '唔…嗯嗯嗯？',
        '好吃是好吃，但并非传闻中那么好吃得惊人。',
        '我有个同伴说，“因为是高级货所以才有好吃的错觉，实际上没什么了不起的”',
        '也许他说得对。',
        '唉，你好不容易帮我找来松茸，真是对不住啊。',
        '总之，谢谢你答应我的请求。',
        '这是说好的谢礼。'
      ],
      completed: ['谢谢你答应我的请求。我的人生无悔了。']
    },
    painter: {
      start: [
        '如您所知，这里是个进行非人类劳动的地方。',
        '我在被带来这里之前，是一名画家。',
        '虽然我喜欢绘画，但是作品总卖不出去。',
        '我家本来就不富裕，生活比较艰苦。',
        '有段时期我变得自暴自弃，将自己的画撕得粉碎并扔掉了。',
        '尽管如此，生活还勉强能维持下去。',
        '可是某天，母亲的身体出了毛病，卧床不起。',
        '虽然马上就打算送往医院，但母亲却因为在意医疗费而拒绝治疗。',
        '她说，“这种小病睡一觉就好。我不要紧的，你继续你的工作吧”。',
        '确实，我们连去医院的钱都没有。',
        '我就当那只是普通的感冒之类的，听母亲的话继续绘画。',
        '但母亲却日益憔悴，到最后甚至连说话都很勉强。',
        '我就是个窝囊废，虽然比平时更加努力绘画，却依然是没能卖出去。',
        '我不得已向高利贷借了医药费。',
        '然后让母亲住了院。',
        '母亲担心金钱的问题，我便骗她说，“我的画终于是有人赏识，开始卖出去了”。',
        '母亲展露出一副打心底里感到开心的表情。',
        '……',
        '……母亲最终还是去世了。',
        '我打算整理母亲用过的衣柜，于是将其打开，发现里面装入了大量纸片。',
        '……那些都是当年我自暴自弃时，被我撕得粉碎后扔掉的画作。',
        '母亲时常对我说。',
        '“我的梦想就是希望你能实现你的梦想，你要永不放弃地不断努力啊”。',
        '所以我现在也一有时间就继续绘画。',
        '可是就算我工作一辈子，也不可能离开这个地方了吧。',
        '所以我拜托您。可以替我将这幅画卖出去吗？'
      ],
      talked: ['求求您了。可以替我将这幅画卖出去吗？'],
      options: ['可以', '不要'],
      answer1: [
        '非常感谢！',
        '穿过秋天的森林，那里有间宅邸。',
        '请将画作带到那里去看看。',
        '那么有劳了。'
      ],
      answer2: ['……是嘛。'],
      started: [
        '穿过秋天的森林，那里有间宅邸。',
        '请将画作带到那里去看看。'
      ],
      lost: ['喂，请把画作拿好再走啊。'],
      complete: [
        '欸！？我的画作卖出去了！？',
        '好耶！！',
        '太好了……',
        '……啊啊……太好了。',
        '……呜呜，真不好意思啊。',
        '我是喜极而泣……',
        '请您收下的卖画得来的所有金钱。',
        '这次真的非常感谢。'
      ],
      completed: ['真的很谢谢你。']
    },
    collector: {
      start: [
        '俺的兴趣是收集画作。',
        '如果有好画的话就拿来给俺。',
        '俺会高价买下。'
      ],
      options: ['希望你买下这幅画', '没什么事'],
      solve1: ['让俺看看。'],
      log: '交出了《恋》',
      solve2: [
        '嗯。画得还挺不错。',
        '好，俺买下了。',
        '钱给你。'
      ],
      solved: ['替俺向那个画师问声好。']
    },
    child: {
      start: [
        '我说，大姐姐。',
        '你认识在森林深处的洞窟里工作的那些大叔吗？',
        '他们每天都在一直工作。',
        '所以啊，我们的生活都是多亏了那些大叔。',
        '所以我啊，想要去和大叔们道谢，',
        '但是妈妈说我不可以去那里。',
        '所以大姐姐，',
        '我希望你替我去跟他们说一声“谢谢你们”。'
      ],
      options: ['可以啊', '不要'],
      answer1: [
        '真的吗！？',
        '那么把这幅画也带上吧！',
        '画的是正在努力工作的大叔们！',
        '他们会喜欢吗？',
        '那拜托你啦！'
      ],
      answer2: ['坏人。'],
      started: ['帮我把我的画作送过去吧！'],
      lost: ['喂！拿好再走啊！'],
      complete1: [
        '啊，大姐姐！',
        '你替我把画送过去了呢！',
        '谢谢你！这是谢礼！'
      ],
      complete2: ['再见啦！'],
      completed: ['上次谢谢你啦！']
    },
    miner: {
      greet: ['啊？你有啥事？'],
      options: ['交出画作', '没什么事'],
      log: '交出了《努力的矿工》',
      solve: [
        '你说这是宅邸那个小鬼给俺们的礼物？',
        '呵，真是个高高在上的主儿。',
        '得到画作这种玩意儿，也填不饱俺们的肚子。',
        '……嗯？',
        '噢，这个装裱画作的画框好像能卖个好价钱。',
        '很好很好，过了这么久，看来总算能吃顿饱饭了。',
        '妹子，麻烦你去让那小鬼继续帮我们画画吧。',
        '再见。'
      ],
      regain: {
        options1: ['我要买下刚才的画作', '没什么事'],
        start: [
          '你说要买下来？',
          '那好吧。',
          '你就收集4种宝石过来。',
          '用作交换。'
        ],
        options2: ['交出4种宝石', '没什么事'],
        logs: [
          '交出了1个蓝宝石',
          '交出了1个绿宝石',
          '交出了1个紫水晶',
          '交出了1个红宝石'
        ],
        complete: [
          '好，你拿来了。',
          '谢咯。',
          '再见。'
        ]
      }
    },
    lady1: {
      start: [
        '女人的魅力在于“美丽”。',
        '而这世上最美的人是我。',
        '对，甚至比隔壁房间那个歹毒的女人更美。',
        '但是啊，我也会随着岁月流逝而变老。',
        '那样的话迟早会比不上年轻女子。',
        '我才不要那样。',
        '我有的是钱，凡事都要做到最好。',
        '于是我派人调查。',
        '穿过外面的森林走到尽头有间医院，你知道吗？'
      ],
      started: [
        '那间医院，似乎研制出了不老不死之药。',
        '听说至今被藏在医院的某处。',
        '所以我要请你去帮我找一找。',
        '我会给你丰盛的谢礼。'
      ],
      options: ['交出1个不老不死之药', '不交出药物'],
      log: '交出了1个不老不死之药',
      solve1: [
        '这就是不老不死之药！？',
        '事不宜迟，让我试试效果。',
        '………'
      ],
      solve2: [
        '！！',
        '感觉肌肤增加了不少光泽，变得更加白嫩了。',
        '我将永远保持这份年轻！！',
        '你做得很好！',
        '这是谢礼！'
      ],
      solved: [
        '你做的很好！',
        '我永远是最美丽的！'
      ]
    },
    lady2: {
      greet: ['隔壁房间那个自恋女，真让我不爽。'],
      start: [
        '隔壁房间那个自恋女，好像得到了不老不死之药什么的。',
        '啊啊，真不爽。',
        '我说，',
        '你去帮我杀掉那个女人。',
        '说什么不老不死，',
        '用火枪之类的击杀不也没辙吗？',
        '愚蠢的女人。'
      ],
      started: [
        '你那是什么表情？',
        '快去杀了她。',
        '比起那个女人给你的，',
        '我会给你更想要的东西作为谢礼。'
      ],
      complete1: [
        '做得好。',
        '给你谢礼。'
      ],
      complete2: [
        '青春常驻这种事根本不可能。',
        '正因为我们的生命有限才显得美丽。',
        '居然没想到那一点，真是可怜的女人。'
      ],
      completed: ['烦人的家伙消失后，我可是爽快多了。']
    },
    forever: {
      ghost: {
        start: [
          '你能看到我吧！？',
          '啊，那么我有件事请你帮忙。',
          '可以请你听我一言吗？'
        ],
        options: ['是', '否'],
        answer1: [
          '太好了。',
          '如你所见，我已经死了。',
          '我还活着的时候，在这间医院里住院。',
          '我的主治医生同时也是我的丈夫。',
          '不管他工作多么累，每天晚上都会在这里握着我的手。',
          '他和我都知道，我的病是绝症，不剩多少日子了。',
          '但是丈夫一直鼓励我，“我会一直在你身边哦”。',
          '但是，不久后病情恶化，我终于是大限将至了。',
          '本打算做好觉悟的，但我已经害怕得不行。',
          '我向紧握着我的手的丈夫问道。',
          '“……你可以……永远在我身边吗？”',
          '他回答道，“我答应你”。',
          '听到他那么说，我感到非常安心。',
          '当天晚上，我就去世了。',
          '在那之后，我醒来的时候，就已经是以这种姿态在医院彷徨了。',
          '我没有前往天国。',
          '因为丈夫不在那里。',
          '说好要永远陪着我的，但他却不在身边。',
          '他是忘记了我们的约定吗？',
          '我明明一直在这里等着他……',
          '所以我恳求你。'
        ],
        answer2: ['………'],
        started: [
          '请把我丈夫带来我这里。',
          '他现在应该还在这间医院里工作。',
          '但是他还活着。',
          '活着就无法和我一同去往天国了。',
          '你知道该怎么做吧？',
          '你是我唯一的依靠。',
          '那么，有劳了。'
        ],
        complete: [
          '啊！是你！',
          '你把我丈夫带到这里来了呢。',
          '这样我们就能永远在一起了。',
          '真是非常感谢。',
          '这是谢礼。'
        ],
        completed: [
          '这样我们就能永远在一起了。',
          '真是非常感谢。'
        ]
      },
      doctor: {
        greet: [
          '很久以前，我的妻子在这间病房里去世了……',
          '不过我现在也努力地积极面对。'
        ],
        start1: [
          '欸？',
          '您说您遇到了我妻子的幽灵？',
          '请不要开这种恶劣的玩笑。',
          '……欸？',
          '我妻子拜托您将我带去她那里？',
          '请，请等一下。',
          '如您所见，我现在还活得好好的啊？',
          '………',
          '请、请饶我一命吧。',
          '我还不想死啊。',
          '我想和其他人再婚、长命百岁啊。'
        ],
        start2: ['……总之，请您不要再说这种唬人的话。'],
        completed: [
          '为什么杀了我。',
          '您和我的妻子，把我的人生当成什么了。',
          '这样太过分了。'
        ]
      }
    },
    raptor: {
      start: [
        '我前段日子看了有关恐龙的电影。',
        '真是太赞了。',
        '你想见识一下真正的恐龙吗？',
        '我不想。',
        '要是真见到了，那些家伙就会变得跟普通动物没两样吧。',
        '只从残留的化石中想象其形态。',
        '那就是浪漫吧？'
      ],
      advice: [
        '喂，你有好多化石啊。',
        '难道不是恐龙的化石吗？',
        '你去组装一下。',
        '如果是恐龙化石的话请让给我。'
      ],
      give: [
        '噢！那不是恐龙化石吗！',
        '拜托了！请让给我吧！'
      ],
      options: ['可以啊', '才不要'],
      cancel: [
        '是嘛……真遗憾。'
      ],
      log: '交出了恐龙化石',
      gave: [
        '卧槽！终于得到了恐龙的化石！',
        '喂，这是谢礼。',
        '感谢。'
      ],
      completed: [
        '嘿嘿嘿，终于得到了恐龙的化石！'
      ]
    },
    brain: {
      message: '艾米丽小姐的脑中，有好多艾米丽小姐呢。',
      kajitsu1: [
        '如何？吓到了吗？',
        '人类就是如此。',
        '很遗憾，这个世界里没有您的容身之处。'
      ],
      kajitsu2: [
        '这样就下定决心了吧？',
        '现在的您，能下决心离开这个世界了吧'
      ],
      kajitsu3: [
        '我在心脏的房间等您。',
        '准备好之后就请过来吧。'
      ],
      kajitsu4: [
        '离开这里，让艾米丽小姐解脱吧。'
      ]
    },
    dream: {
      kajitsu1: ['您来了。'],
      kajitsu2: [
        '接下来您将从艾米丽小姐的心中离开，启程前往死后的世界。',
        '如此，徘徊于生死之间的艾米丽小姐马上就会醒来。'
      ],
      kajitsu3: ['做好心理准备了吗？'],
      yesno: ['是', '否'],
      cancel: ['那么，请做好准备之后再来。'],
      kajitsu4: ['那么，请您念想着要迫切离开这里。'],
      message: '太好了。看来是醒过来了呢。',
      amili1: [
        '莉卜拉，抱歉一直瞒着你。',
        '之前和你说过的话，全都是骗你的……'
      ],
      amili2: [
        '这个世界并不是我的心中。',
        '这个世界是……',
        '你的心中。'
      ],
      amili3: [
        '其实死去的是我，彷徨在生死之间的是你。',
        '能想起来吗？'
      ],
      amili4: [
        '这是你的心脏。',
        '我作为亡灵留在你的心中。',
        '你封闭了自己的内心，所以没能苏醒。',
        '于是我为了让你下决心离开这里，对你说了谎。'
      ],
      amili5: [
        '莉卜拉的脑海里，想的全是我呢。',
        '……我好开心。',
        '嘻嘻。因为净是记挂着我，所以才无法苏醒吧？'
      ],
      amili6: [
        '但是……已经不要紧了。',
        '你要连着我的份一起好好活下去。'
      ],
      amili7: [
        '我会永远留在这里……留在你的心中。',
        '永别了。'
      ],
      options: ['谢谢你一直以来的照顾', '强烈希望不要离开'],
      last1: {
        amili1: [
          '……莉卜拉。',
          '……来生再会。'
        ],
        message: '这只是暂时的离别。'
      },
      last2: {
        amili1: ['欸，什么？'],
        amili2: ['！！'],
        amili3: ['……莉卜拉！'],
        amili4: ['……你死了？'],
        amili5: ['怎么会……'],
        amili6: [
          '……为什么？',
          '不惜做到这份上，也要和我一起……？'
        ],
        message: '今后永远在一起。'
      }
    },
    cosmos: {
      minePenguin1: [
        '喂，你看看那边的地面。',
        '描画着不可思议的图案对吧？',
        '那当中肯定藏着什么秘密。',
        '我是解不开那个谜题，你也可以试试看。'
      ],
      minePenguin2: [
        '你说你去了宇宙？',
        '那可真厉害啊。',
        '且不说这话可信度如何……',
        '从这种章鱼房间出发去宇宙什么的，谢谢你告诉我这样充满梦想的故事。'
      ],
      guide1: [
        '我们是外星人。',
        '想去宇宙的话，就搭上那边的UFO吧。'
      ],
      guide2: [
        '来到宇宙了。',
        '人类来到宇宙之后，马上就会迷失其中。',
        '所以请不要走得太远。',
        '但是，真正的宇宙比你见到的要大得多。'
      ],
      evolution: [
        '你们真的觉得自己是从老鼠或者猴子进化而来的吗？',
        '稍作思考就知道并非如此。',
        '你们是其他星球的生命体所创造的。',
        '你们作为奴隶而被创造出来。为了防止你们叛乱，你们的端粒——也就是预期寿命被设定为100年。',
        '仔细观察地球上的其他生物吧。',
        '只有你们人类会在发育成熟后仍然会随着老化而改变外表。',
        '话先说在前头，把你们做成奴隶的外星人，可不是我们格雷星人。',
        '话说，你知道你们人类中的东洋人和西洋人的瞳色为什么不一样吗？',
        '因为东洋人是由灵长类加工而成，而西洋人是由爬虫类加工而成的。',
        '所以，你们说“从猴子进化而来”或许也未必有错。'
      ]
    },
    photosynthesis: {
      greeting: [
        '哟。你是人类啊。',
        '对人类来说，我们格雷星人应该是最亲近的外星人吧。',
        '在我们看来，人类也是最亲近的研究对象。',
        '在我们看来，人类最感兴趣的是饮食和生殖。',
        '我们不会吃喝，也不会进行有性生殖。'
      ],
      questions: ['那你们如何获得营养？', '那你们如何生孩子？'],
      answer1: [
        '我们会进行光合作用。',
        '在你看来，我们格雷星人是什么颜色的？',
        '绿色？灰色？',
        '都是对的。',
        '我们平时是绿色的，长时间没有进行光合作用就会变成灰色。',
        '也就是说，我现在饿着肚子。'
      ],
      answer2: [
        '那是秘密。',
        '我们也打算研究你们的生殖，但不知道为什么，没有人愿意合作。'
      ],
      start: [
        '话说，人类。',
        '我希望你协助我们的研究。',
        '我们想知道饮食相关的情报。',
        '将地球上的料理拿过来给我。',
        '拿你推荐的过来就好。'
      ],
      started: [
        '很好，下一个。',
        '将更多的地球上的料理拿过来给我。'
      ],
      option: '交出#{name}',
      cancel: '放弃',
      log: '交出了#{name}',
      omurice: [
        '这是，所谓的蛋包饭吗。',
        '我来尝一口吧。',
        '……',
        '呼姆呼姆。',
        '这黏糊糊的黄色，加上浇在上面的酸甜的红色液体，好吃极了。',
        '不过，果然还是光合作用更美味。'
      ],
      steak: [
        '这是，所谓的牛排吗。',
        '我来尝一口吧。',
        '……',
        '呼姆呼姆。',
        '鲜嫩多汁啊。',
        '但是用我们的下颚来吃这个实在是很辛苦',
        '果然还是光合作用更美味。'
      ],
      curry: [
        '这是，所谓的咖喱吗。',
        '我来尝一口吧。',
        '……',
        '嗯',
        '味道不错啊。',
        '呼姆呼姆。',
        '这个在嘴里辣乎乎的。',
        '已经不需要了。',
        '果然还是光合作用更美味。'
      ],
      stirFry: [
        '这是，所谓的炒青菜吗。',
        '我来尝一口吧。',
        '……',
        '呼姆呼姆。',
        '爽脆的口感真不错。',
        '不过，果然还是光合作用更美味。'
      ],
      complete: [
        '很好，我已经填饱肚子了。',
        '这个就当做是你协助研究的谢礼吧。',
        '是从地球上采集到的。'
      ],
      completed: [
        '相较于你们的料理，还是光合作用更美味。',
        '你们也进行光合作用就好了。'
      ]
    },
    bogusDoctor: {
      talk1: [
        '你不是这间医院的患者吧？',
        '哎呀，既然如此，请务必听一下我多年来的烦恼。',
        '你能保证不把这件事告诉任何人吗？'
      ],
      options1: ['能', '不能'],
      cancel: ['是嘛。'],
      talk2: [
        '太好了。',
        '事实上，这家医院以前一个医生也没有。',
        '只有患者。',
        '因此，患者们当然没有得到任何处理就死去了。',
        '我并不是医生，但我实在看不下去了。',
        '我读着医院的医学书，瞎猜半蒙地给患者开了药。',
        '有病情好转的，也有因为我的错误而恶化的。',
        '不知不觉间，患者们把我当成了医生。',
        '终于，仅用药物已经没有任何效果了，必须进行手术。',
        '不管读了多少书，都不可能顺利做手术。',
        '理所当然地，我三番五次失败了。',
        '准确来说，我三番五次杀死了患者。',
        '即便如此，患者们也只能求助于唯一的冒牌医生。',
        '从那以后，手术的技巧进步了，能够挽救患者的生命了。',
        '但是，过去因我的手术而死去的患者们在我的脑海里挥之不去。',
        '他们痛苦呻吟的脸、他们的声音，总是在脑海中挥之不去。',
        '我开始纠结了。'
      ],
      talk3: [
        '如果能拯救比他们多几十倍、几百倍的生命，他们不也能瞑目了吗？',
        '我不也能被原谅吗？',
        '我这样想着，每天拼命地救助患者们。',
        '但是，我到现在也不知道。',
        '我被原谅了吗？'
      ],
      options2: ['你是伟大的医生', '他们怨恨你'],
      answer1: [
        '你竟然这么说。',
        '啊，感觉肩上的担子减轻了一些。'
      ],
      answer2: [
        '说的是呢。',
        '牺牲自己，即使救助再多人，在当事人看来也是不合情理的。',
        '这个赎罪是我的自我满足罢了。',
        '我再次下定决心。',
        '我将用一生来弥补这个罪孽。'
      ],
      complete: [
        '感谢你倾听我的故事。',
        '这是谢礼。'
      ],
      completed: [
        '好了，不能这样消沉下去了。',
        '因为患者们在等着我。'
      ],
      patient0: [
        '医生，这边来一下。',
        '请过来这边。'
      ],
      patient1: [
        '你说自己是医生，这是骗人的吧。',
        '……好过分。',
        '我的身体，变得这么伤痕累累……'
      ],
      patient2: [
        '好冷。我好冷啊。',
        '医生，为什么我的身体会这么冷？',
        '医生……救我。'
      ],
      patient3: [
        '好痛！！',
        '我好痛啊，医生！！',
        '痛得要命，已经撑不住了！！',
        '快想想办法啊！！'
      ],
      patient4: [
        '医生，你说做手术就能救我的命，这是骗人的？',
        '这是怎么回事啊。',
        '我这是死了啊……'
      ],
      patient5: [
        '即便你不是真正的医生，我也感谢你。',
        '你为了救我的命而拼命努力了。',
        '我不怨恨你。',
        '来，打开房间的灯。',
        '请永远做一个善良的医生吧。'
      ],
      lockMap: '你逃不掉的' // There is no escape
    }
  },
  happyend: {
    title: 'Happy End',
    lyrics: [
      '倘若夜风的声音是神明的声音',
      '去听吧 直到太阳升起',
      '然后将会得到一颗温柔的心',
      '试着为别人而活',
      '倘若我死之日是世界末日',
      '没有人会悲伤',
      '即使那一天明日到来',
      '也不过闪耀着一束光而已',
      '日落之时闻听的歌曲',
      '唱的都是美妙的事物',
      '纵然你落下的雨水是眼泪',
      '只要我的心架起彩虹',
      '便是伴随着欢快旋律的快乐结局',
      '这样的生活我也感到幸福',
      '我曾经爱过的一个女孩哭了',
      '我假装难过',
      '最喜欢的歌词 最喜欢的声音',
      '撒谎的人看起来也很温柔',
      '纵然你落下的雨水是眼泪',
      '只要我的心架起彩虹',
      '便是伴随着欢快旋律的快乐结局',
      '这样的生活我也感到幸福',
      '即便明天早上是世界末日',
      '也不要露出那种悲伤的表情'
    ]
  }
}
